import { useEffect, useState } from 'preact/hooks'

const STEPS = [
  'Reading your PDF…',
  'Detecting invoice boundaries…',
  'Extracting vendor and amount…',
  'Almost there…',
]

const STEP_INTERVAL_MS = 1800

/**
 * Animated placeholder shown while the analyze API call is in flight. Sells
 * the "AI is working" moment instead of a static "Analyzing..." line —
 * matters because the call can take 2–6 seconds and silent waits feel broken.
 */
export default function AnalyzingState() {
  const [stepIndex, setStepIndex] = useState(0)

  useEffect(() => {
    const id = setInterval(() => {
      // Advance, but stop on the last step so it doesn't loop weirdly if the
      // server takes longer than expected.
      setStepIndex((i) => Math.min(i + 1, STEPS.length - 1))
    }, STEP_INTERVAL_MS)
    return () => clearInterval(id)
  }, [])

  return (
    <div class="sis-analyzing">
      <div class="sis-analyzing-icon" aria-hidden="true">
        <span class="sis-spinner-dot" />
        <span class="sis-spinner-dot" />
        <span class="sis-spinner-dot" />
      </div>
      <p class="sis-analyzing-step">{STEPS[stepIndex]}</p>
      <div class="sis-analyzing-bar" aria-hidden="true">
        <span />
      </div>
    </div>
  )
}
